import { render } from "./KDPSalesNoteLinkNavigationContainer.vue?vue&type=template&id=481a0868&scoped=true&ts=true"
import script from "./KDPSalesNoteLinkNavigationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./KDPSalesNoteLinkNavigationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./KDPSalesNoteLinkNavigationContainer.vue?vue&type=style&index=0&id=481a0868&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481a0868"],['__file',"src/components/KDPSalesNoteLinkNavigationContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "481a0868"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('481a0868', __exports__)) {
    console.log('reload')
    api.reload('481a0868', __exports__)
  }
  
  module.hot.accept("./KDPSalesNoteLinkNavigationContainer.vue?vue&type=template&id=481a0868&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('481a0868', render)
  })

}


export default __exports__